export default {
  Created: 0, // đã lập
  Sent: 1, // Đã nộp
  Approved: 2, // Đã nhận
  Rejected: 3, // Từ chối
  Summarized: 6 //Đã tổng hợp
};
